

import React, { useEffect, useState } from "react";
import Classes from "../../asset/styles/AdminCMSSettings.module.css";
import AdminLayout from "../../layout/AdminLayout";
import { getSocialMedaiLink, socialMediaLink } from "../../actions/cmsActions";
import toast from "react-hot-toast";

const SocialMediaLink = () => {

    const [twitterLink, setTwitterLink] = useState("");
    const [telegramLink, setTelegramLink] = useState("");
    const [facebookLink, setFacebookLink] = useState("");
    const [discordLink, setDiscordLink] = useState("");
    const [socialMediaId, setSocialMediaId] = useState("");

    const handleSaveSocialMedia = async () => {
        // e.preventDefault();

        const socialLinks = {
            twitter: twitterLink,
            telegram: telegramLink,
            facebook: facebookLink,
            discord: discordLink,
            id: socialMediaId
        };

        try {
            const result = await socialMediaLink(socialLinks);
            if (result.statusCode == 200 && result.status == true) {
                socialLink();

                toast.success(result.message);
                return;
            } else {
                toast.error(result.message);
                return;
            }
        } catch (error) {
            toast.error('Error saving social media links');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case "twitter":
                setTwitterLink(value);
                break;
            case "telegram":
                setTelegramLink(value);
                break;
            case "facebook":
                setFacebookLink(value);
                break;
            case "discord":
                setDiscordLink(value);
                break;
            default:
                break;
        }
    };

    const socialLink = async () => {
        try {
            const getLinks = await getSocialMedaiLink();

            setTwitterLink(getLinks.data[0].twitter)
            setTelegramLink(getLinks.data[0].telegram)
            setFacebookLink(getLinks.data[0].facebook)
            setDiscordLink(getLinks.data[0].discord)
            setSocialMediaId(getLinks.data[0]._id)
        } catch (error) {

        }
    };

    useEffect(() => {
        socialLink();
    }, [])

    return (
        <AdminLayout>
            <div className={`${Classes.adminChangeCont} p-2 p-sm-3 p-md-4 p-lg-5`}>
                <h2 className={`${Classes.launchpad__title} text-uppercase aboro_font`}>
                    Social Media Settings
                </h2>

                {/* <form onSubmit={handleSaveSocialMedia}> */}
                <div className={`${Classes.singleInpHolder} mt-3`}>
                    <label htmlFor="twitter" className={`${Classes.inputLabel} orbitron`}>
                        Twitter
                    </label>
                    <br />
                    <input
                        type="text"
                        id="twitter"
                        name="twitter"
                        className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                        placeholder="Enter Twitter URL"
                        autoComplete="off"
                        value={twitterLink}
                        onChange={handleChange}
                    />
                </div>

                {/* <div className={`${Classes.singleInpHolder} mt-3`}>
                    <label htmlFor="telegram" className={`${Classes.inputLabel} orbitron`}>
                        Telegram
                    </label>
                    <br />
                    <input
                        type="text"
                        id="telegram"
                        name="telegram"
                        className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                        placeholder="Enter Telegram URL"
                        autoComplete="off"
                        value={telegramLink}
                        onChange={handleChange}
                    />
                </div> */}

                {/* <div className={`${Classes.singleInpHolder} mt-3`}>
                    <label htmlFor="facebook" className={`${Classes.inputLabel} orbitron`}>
                        Facebook
                    </label>
                    <br />
                    <input
                        type="text"
                        id="facebook"
                        name="facebook"
                        className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                        placeholder="Enter Facebook URL"
                        autoComplete="off"
                        value={facebookLink}
                        onChange={handleChange}
                    />
                </div> */}

                <div className={`${Classes.singleInpHolder} mt-3`}>
                    <label htmlFor="discord" className={`${Classes.inputLabel} orbitron`}>
                        Discord
                    </label>
                    <br />
                    <input
                        type="text"
                        id="discord"
                        name="discord"
                        className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
                        placeholder="Enter Discord URL"
                        autoComplete="off"
                        value={discordLink}
                        onChange={handleChange}
                    />
                </div>
                <div className="w-100 d-flex justify-content-center">
                    <button
                        type="submit"
                        className={`${Classes.whiteBtn} my-3 mx-auto`}
                        onClick={() => handleSaveSocialMedia(socialMediaId)}
                    >
                        Save Social Media Links
                    </button>
                </div>


                {/* </form> */}
            </div>
        </AdminLayout>
    );
};

export default SocialMediaLink;
